import CryptoJS from 'crypto-js';

const secretKey = import.meta.env.VITE_CRYPTO_SECRET;

export function useCrypto() {
  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };

  const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  return {
    encryptData,
    decryptData,
  };
}
